/**
 * 竞价出价记录详细
 */

import React from 'react';
import '../../../style/ui/visitor.css';
import server from '../../../axios/server';
import http from '../../../axios/http';
import { Tabs, Modal, Button } from 'antd';
import VisitorList from './VisitorList';
import NotFound from '../../common/NotFound';
const { TabPane } = Tabs;

class Visitor extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            countDown: {
                //倒计时
                hour: "00", //小时
                minute: "00", //分钟
                second: "00", //秒
                ms: "000", //毫秒
            },
            sessionSituation: {
                status: 0,
                statusStr: '',
                currentLotsIndex: 0
            }, // 当前场次状态
            showCountDown: false,
            localLotsIndex: 0, //当前显示的是第几个竞价品的信息，页面显示使用 
            lotsList: [],  //竞拍场次列表   
            sessionInfo: {},
            vehicleList: [],
            records: [],  // 出价记录
            showRecords: [], //  出价记录前三条
            sessionId: '',
            token: '',
            bidResultInfo: {
                title: '', //标题，状态
                content: '', //内容信息
                nextBidSecond: 0, //进入下一个竞价品倒计时
                visible: false
            },
            currentPrice: 0, //当前价格
            firstWxConn: true,
            visitorListVisible: false,
            notFind: false,
            currentPriceStr: ''
        };
    }
    componentDidMount() {
        // let sessionSituation = this.state.sessionSituation
        // 获取路径中的Session和token
        // let pathname = window.location.href;
        let pathname = window.location.pathname;
        let params = pathname.split('/');
        let sessionId = params[3];
        let token = params[4];
        if (sessionId === undefined || token === undefined) {
            // 如果 sessionId或者token为空，则默认竞价场次已结束
            // sessionSituation.status =  2
            this.setState({
                // sessionSituation:sessionSituation
                notFind: true
            })
        } else {
            this.setState({
                sessionId: sessionId,
                token: token
            })
            this.getSessionInfo(sessionId);
        }

    }
    // 判断结束是否在当天
    lotsIsShowTime = (endTime) => {
        let endTimes = new Date(endTime).getTime()
        let date = new Date();
        let yy = date.getFullYear();
        let mm = date.getMonth() + 1;
        let dd = date.getDate();
        mm = (mm < 10 ? "0" + mm : mm);
        let time1 = yy + '/' + mm + '/' + dd + ' 00:00:00'
        let time2 = yy + '/' + mm + '/' + dd + ' 23:59:59'
        let morningTimes = new Date(time1).getTime()
        let nightTimes = new Date(time2).getTime()
        if (endTimes > morningTimes && endTimes < nightTimes) {
            return true
        } else {
            return false
        }
    }
    // 获取场次信息
    getSessionInfo = (sessionId) => {
        let sessionSituation = this.state.sessionSituation;
        let url = "/common/image";
        http.get({
            url: '/mall/auctionVisitor/getSessionInfo',
            data: {
                sessionId: sessionId
            },
            success: (res) => {
                res.imageThumbnail = 'data:image/jpg;base64,' + res.imageThumbnail
                res.image = server.httpServerUrl + url + "?imagePath=" + encodeURI(res.image)
                // imageUrls.push(server.httpServerUrl + url + "?imagePath=" + encodeURI(item));
                if (res.lots && res.lots.length > 0) {
                    for (let i = 0; i < res.lots.length; i++) {
                        res.lots[i].vehicleImageUrl = server.httpServerUrl + url + "?imagePath=" + encodeURI(res.lots[i].vehicleImageUrl)
                        res.lots[i].vehicleImageThumbnail = 'data:image/jpg;base64,' + res.lots[i].vehicleImageThumbnail
                        res.lots[i].startPriceStr = this.numFormat(res.lots[i].startPrice)
                        if (res.lots[i].finalPrice !== undefined && res.lots[i].finalPrice !== null) {
                            res.lots[i].finalPriceStr = this.numFormat(res.lots[i].finalPrice)
                        }
                    }
                }
                this.setState({
                    lotsList: res.lots,
                    sessionInfo: res,
                    sessionSituation: sessionSituation
                })
                this.getCurrentSituation(sessionId);
            }
        })
    }
    // 获取竞价场次状态
    getCurrentSituation = (sessionId) => {
        let sessionSituation = this.state.sessionSituation;
        let currentPrice = this.state.currentPrice;
        let currentPriceStr = this.state.currentPriceStr;
        let lotsList = this.state.lotsList;
        let showCountDown = true;
        http.get({
            url: '/mall/auctionVisitor/getCurrentSituation',
            data: {
                sessionId: sessionId
            },
            success: (res) => {
                sessionSituation.currentLotsIndex = res.currentLotsIndex
                sessionSituation.status = res.status;
                if (res.status === 0 || res.status === 3) {
                    sessionSituation.statusStr = '未开始';
                    let date = new Date(res.startTime);
                    let now = new Date().getTime();
                    sessionSituation.startTime = date.getTime();
                    if ((sessionSituation.startTime - now) > 86400000) {
                        //如果开始时间超过一天的话，则不显示倒计时
                        showCountDown = false;
                    } else {
                        if (!this.state.showCountDown) {
                            showCountDown = true;
                        }
                    }
                    // 未开始起始价直接拿第一个
                    if (lotsList != null && lotsList.length > 0) {
                        currentPrice = lotsList[0].startPrice;
                        currentPriceStr = this.numFormat(currentPrice)
                        this.getVehicleInfo(lotsList[0].vehicleIds)
                    } else {
                    }
                    this.setState({
                        currentPrice: currentPrice,
                        currentPriceStr: currentPriceStr,
                        showCountDown: showCountDown
                    })
                    this.initWebSocket(sessionId)
                    this.countTimeDown();
                } else if (res.status === 1) {
                    sessionSituation.statusStr = '进行中';
                    sessionSituation.endTime = res.endTime;
                    showCountDown = false;  //进行中的倒计时由webSocket触发，这里设置为false

                    // 进行中根据当前竞价到第几个的index去拿起始价
                    if (lotsList != null && lotsList.length > 0) {
                        currentPrice = lotsList[sessionSituation.currentLotsIndex].startPrice;
                        currentPriceStr = this.numFormat(currentPrice)
                        this.getVehicleInfo(lotsList[sessionSituation.currentLotsIndex].vehicleIds)
                    }
                    this.setState({
                        currentPrice: currentPrice,
                        currentPriceStr: currentPriceStr,
                        visitorListVisible: true
                    })
                    this.initWebSocket(sessionId)
                } else if (res.status === 2) {
                    let notFind = this.lotsIsShowTime(this.state.sessionInfo.endTime)
                    // let notFind = this.lotsIsShowTime('2020-11-12 12:21:00')
                    showCountDown = false;
                    this.setState({
                        notFind: !notFind
                    })
                }
                this.setState({
                    sessionSituation: sessionSituation,
                    firstWxConn: true,
                    localLotsIndex: sessionSituation.currentLotsIndex, //当前显示的是第几个竞价价的信息 
                    showCountDown: showCountDown, //是否显示倒计时，用于标志是否需要进行倒计时
                })
            }
        })
    }
    // 获取车辆信息
    getVehicleInfo = (vehicleIds) => {
        http.get({
            url: '/mall/auctionVisitor/getVehicleInfo',
            data: {
                vehicleIds: vehicleIds
            },
            success: (res) => {
                let vehicleList = res;
                // for (let i = 0; i < vehicleList.length; i++) {
                //     if (vehicleList[i].examinationDate !== undefined) {
                //         vehicleList[i].examinationDateStr = this.formatDateMonthDay(vehicleList[i].examinationDate,
                //             'month');
                //     }
                //     if (vehicleList[i].registerDate !== undefined) {
                //         vehicleList[i].registerDateStr = this.formatDateMonthDay(vehicleList[i].registerDate,
                //             'day');
                //     }
                //     if (vehicleList[i].productionDate !== undefined) {
                //         vehicleList[i].productionDateStr = this.formatDateMonthDay(vehicleList[i].productionDate,
                //             'day');
                //     }
                //     if (vehicleList[i].commerciaInsuranceDate !== undefined) {
                //         vehicleList[i].commerciaInsuranceDateStr = this.formatDateMonthDay(vehicleList[i].commerciaInsuranceDate,
                //             'day');
                //     }
                //     if (vehicleList[i].mandatoryInsuranceDate !== undefined) {
                //         vehicleList[i].mandatoryInsuranceDateStr = this.formatDateMonthDay(vehicleList[i].mandatoryInsuranceDate,
                //             'day');
                //     }
                // }
                this.setState({
                    vehicleList: vehicleList
                })
            }
        })
    }
    // 启动websocket
    initWebSocket = (sessionId) => {
        const websocketUrl = server.websocketUrl + "/mall/auctionVisitor/ws/" + sessionId + '/' + this.state.token
        this.ws = new WebSocket(websocketUrl);
        this.ws.onopen = this.onopen;
        this.ws.onmessage = this.onmessage;
        this.ws.onclose = this.onclose;
    }
    onmessage = (evt) => {
        let objData = JSON.parse(evt.data);
        // 没有访问权限
        if (objData.code === '401') {
            // this.setState({
            //     notFind:true
            // })
            return;
        }
        let wsData = objData.data;

        let status = wsData.status; //竞价场次状态，0：未开始，1：进行中，2：已结束，3：竞价品间休息
        if (this.state.sessionSituation.status === 0 && status !== 0) {
            //如果竞价场次状态是未开始，则需要跳到第一个竞价品
            let sessionInfo = this.state.sessionInfo;
            sessionInfo.status = 1;
            this.setState({
                localLotsIndex: 0,
                sessionInfo: sessionInfo
            });
        }
        let lotsList = this.state.lotsList;
        let currentLotsIndex = wsData.currentLotsIndex ? wsData.currentLotsIndex : 0;
        let currentPrice = this.state.currentPrice;
        let currentPriceStr = this.state.currentPriceStr;

        //设置出价记录
        let bidTimes = 0;
        //保存出价记录
        let records = [];

        if (wsData.records !== undefined && wsData.records !== null & wsData.records.length > 0) {
            currentPrice = wsData.records[0].offer;
            currentPriceStr = this.numFormat(currentPrice);

            bidTimes = wsData.records.length;
            //返回数据的时间格式已经是中文版本，无需处理
            // for (let i = 0; i < bidTimes; i++) {
            //     let bidTime = wsData.records[i].bidTime;
            //     wsData.records[i].bidTime = this.formatDateTime(new Date(bidTime));
            // }
            // lotsList[currentLotsIndex].bidTimes = bidTimes;
            // lotsList[currentLotsIndex].bidRecords = wsData.records;

            for (let i = 0; i < wsData.records.length; i++) {
                wsData.records[i].bidTime = this.formatDateTime(new Date(wsData.records[i].bidTime));
            }
            lotsList[currentLotsIndex].bidTimes = bidTimes;
            wsData.records = wsData.records.slice(0, 3)
            lotsList[currentLotsIndex].bidRecords = records;

            this.setState({
                bidTimes: bidTimes,
                records: wsData.records,
                currentPriceStr: currentPriceStr
            })

            // 判断我是否有出价
        } else {
            currentPrice = lotsList[currentLotsIndex].startPrice;
        }
        //根据竞价状态处理数据
        if (status === 0) {
            //未开始
            currentPrice = lotsList[0].startPrice;
        } else if (status === 1) {
            //进行中,
            //如果是在显示出价窗口的额时候，需要同时变动数据
            if (this.state.offerVisible) {
                let addPrice = this.state.addPrice;
                let offer = Number(addPrice) + Number(currentPrice);
                this.setState({
                    offer: offer,
                    offerStr: this.numFormat(offer)
                });
            }
        } else if (status === 3 || status === 2) {
            //幕间休息，提示用户当前竞价品的竞价已经结束，即将跳转到下一个竞价品
            //当前竞价品，竞价结束，提示用户，如果用户不再当前竞价价的页面，则不提示
            lotsList[currentLotsIndex].endTime = this.formatDateTime(wsData.endTime);
            if (this.state.localLotsIndex === currentLotsIndex || status === 2) {
                let bidResultInfo = {};
                if (bidTimes === 0) {
                    bidResultInfo.title = "竞价失败";
                    bidResultInfo.content = "无人出价，竞价失败！";
                    if (!this.state.firstWxConn) {
                        lotsList[currentLotsIndex].status = 0;
                    }
                } else if (currentPrice < lotsList[currentLotsIndex].reservePrice) {
                    bidResultInfo.title = "竞价失败";
                    bidResultInfo.content = "低于保留价，竞价失败！";
                    lotsList[currentLotsIndex].status = 2;
                } else {
                    bidResultInfo.title = "成交";
                    bidResultInfo.content = "竞价成功";
                    lotsList[currentLotsIndex].status = 1;
                    lotsList[currentLotsIndex].finalPrice = wsData.records[0].offer;
                    lotsList[currentLotsIndex].finalPriceStr = this.numFormat(wsData.records[0].offer);
                }
                //第一次进来的时候，不做幕间休息的倒计时
                if (!this.state.firstWxConn) {
                    bidResultInfo.visible = true;
                    bidResultInfo.nextBidSecond = 5; //进入下一个竞价品倒计时
                    //当前竞价的竞价品显示为下一个
                    this.setState({
                        bidResultInfo: bidResultInfo, //是否显示倒计时，用于标志是否需要进行倒计时
                    });
                    this.nextBidCountDown();
                    wsData.currentLotsIndex = currentLotsIndex + 1;
                }
            } else if (this.state.localLotsIndex === (currentLotsIndex + 1)) {
                if (!this.state.firstWxConn) {
                    wsData.currentLotsIndex = currentLotsIndex + 1;
                }
            }
        }
        this.setState({
            sessionSituation: wsData,
            firstWxConn: false,
            hasOffer: false
        });
        if (status === 2) {
            let sessionInfo = this.state.sessionInfo;
            sessionInfo.endTime = this.formatDateTime(wsData.endTime);
            sessionInfo.status = 2;
            this.setState({
                sessionInfo: sessionInfo,
                showCountDown: false,
            });

        }
        this.setState({
            currentPrice: currentPrice,
            currentPriceStr: this.numFormat(currentPrice),
            lotsList: lotsList,
        });
        //因为只有进行中的才会进入开启web socket。所以这里需启动倒计时
        if (!this.state.showCountDown) {
            this.setState({
                showCountDown: true
            });
            this.countTimeDown(wsData);
        }
    }

    countTimeDown = (sessionSituation) => {
        // let sessionSituation = this.state.sessionSituation; //当前竞价场次状态
        let sessionSituationInfo = sessionSituation == null ? this.state.sessionSituation : sessionSituation; //当前竞价场次状态
        let time = 0;
        if (sessionSituationInfo.status === 0 || sessionSituationInfo.status === 3) {
            //竞价状态为未开始和幕间休息
            time = sessionSituationInfo.startTime;
        } else if (sessionSituationInfo.status === 1) {
            //竞价状态为进行中
            time = sessionSituationInfo.endTime;
        }
        let diffTime = time - (new Date().getTime()); //时间差
        if (!isNaN(diffTime) && diffTime > 0) {
            // let d = Math.floor(diffTime / 1000 / 60 / 60 / 24);
            let h = Math.floor(diffTime / 1000 / 60 / 60 % 24);
            let m = Math.floor(diffTime / 1000 / 60 % 60);
            let s = Math.floor(diffTime / 1000 % 60);
            let ms = Math.floor(diffTime % 1000);
            let countDown = {
                //倒计时
                hour: h < 10 ? "0" + h : h, //小时
                minute: m < 10 ? "0" + m : m, //分钟
                second: s < 10 ? "0" + s : s, //秒
                ms: ms < 10 ? ("00" + ms) : ms < 100 ? ("0" + ms) : ms, //毫秒
            };
            this.setState({
                countDown: countDown
            });
        } else {
            //设置倒计时为0
            this.setState({
                countDown: {
                    //倒计时
                    hour: "00", //小时
                    minute: "00", //分钟
                    second: "00", //秒
                    ms: "000", //毫秒
                }
            });
        }
        //递归每秒调用countTime方法，显示动态时间效果
        if (this.state.showCountDown) {
            setTimeout(this.countTimeDown, 100);
        }

    }
    /**
     * 格式化时间，格式化完成后的格式为 YYYY-MM-dd HH:mm:ss
     */
    formatDateTime = (date) => {
        if (typeof date === 'number' && !isNaN(date)) {
            date = new Date(date);
        } else if (date instanceof Date) { } else {
            return date;
        }
        var YY = date.getFullYear() + '-';
        var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
        var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
        var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
        var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
        return YY + MM + DD + " " + hh + mm + ss;
    }
    // 格式化到年月日
    formatDateMonthDay = (time, type) => {
        let timearr = time.split("-");
        let yy = timearr[0];
        let mm = timearr[1];
        let dd = timearr[2];
        let str = '';
        if (type === "day") {
            str = yy + '年' + mm + '月' + dd + '日'
        } else if (type === "month") {
            str = yy + '年' + mm + '月'
        }
        return str
    }
    /**
     * 数字格式化
     */
    numFormat = (num) => {
        let result = '';
        let counter = 0;
        num = (num || 0).toString();
        for (var i = num.length - 1; i >= 0; i--) {
            counter++;
            result = num.charAt(i) + result;
            if (!(counter % 3) && i !== 0) {
                result = ',' + result;
            }
        }
        return result;
    }
    /** 进入下一个竞价品 */
    nextLots = () => {
        let localLotsIndex = this.state.localLotsIndex;
        let lotsList = this.state.lotsList;
        if (localLotsIndex >= (lotsList.length - 1)) {
            //已经是最后一个竞价品
            // Dialog.alert({
            // 	message: '已经是最后一个竞价品',
            // }).then(() => {});
            // this.getSessionInfo();
        } else {
            localLotsIndex++;
            this.setState({
                localLotsIndex: localLotsIndex
            });

            //加载车辆信息
            this.getVehicleInfo(lotsList[localLotsIndex].vehicleIds);
        }
    }
    /** 立马进入下一个竞价品 */
    nextBidNow = () => {
        let bidResultInfo = this.state.bidResultInfo;
        bidResultInfo.visible = false;
        bidResultInfo.nextBidSecond = 0;
        this.setState({
            bidResultInfo: bidResultInfo,
        });
        this.nextLots();
    }
    /** 进入下一个竞价品倒计时 */
    nextBidCountDown = () => {
        let bidResultInfo = this.state.bidResultInfo;
        let second = bidResultInfo.nextBidSecond;
        if (second === 1) {
            //如果等于1，说明要进入了
            this.nextBidNow();
        } else if (second > 0) {
            second--;
            bidResultInfo.nextBidSecond = second;
            this.setState({
                bidResultInfo: bidResultInfo,
                records: [],
                bidTimes: 0
            });
            setTimeout(this.nextBidCountDown, 1000);
        }
    }

    goLotsList = () => {
        // let bidResultInfo =this.state.bidResultInfo;
        // bidResultInfo.visible =true
        // this.setState({
        //     bidResultInfo: bidResultInfo,
        // });
        this.setState({
            visitorListVisible: false
        })
    }
    handleOk = (e) => {
        let bidResultInfo = this.state.bidResultInfo;
        bidResultInfo.visible = false
        this.setState({
            bidResultInfo: bidResultInfo,
        });
    };
    closeVisitorListModal = () => {
        this.setState({
            visitorListVisible: true
        })
    }
    detail = (index) => {
        this.setState({
            localLotsIndex: index
        })
        this.getVehicleInfo(this.state.lotsList[index].vehicleIds);
        this.closeVisitorListModal();

    }
    render() {
        let htmlStr = '';
        let countDown = this.state.countDown;
        let lotsList = this.state.lotsList;
        let localLotsIndex = this.state.localLotsIndex;
        let sessionInfo = this.state.sessionInfo;
        let sessionSituation = this.state.sessionSituation;
        if (this.state.notFind) {
            htmlStr = (
                <div className="sessionOver"><NotFound /></div>
            )
        } else {
            if (lotsList != null && lotsList.length > 0) {
                htmlStr = (
                    <div className="visitorbox">
                        {this.state.visitorListVisible ?
                            <div>
                                <div className='visitor-header'>
                                    <div className="leftImg"><img alt="" src={this.state.sessionInfo.lots[localLotsIndex].vehicleImageUrl ? this.state.sessionInfo.lots[localLotsIndex].vehicleImageUrl : ''}></img></div>
                                    <div className="lotsLength">
                                        <div className="txt fl">{localLotsIndex + 1 >= 10 ? '' : "0"}{localLotsIndex + 1}</div>
                                        <div className="fl">/</div>
                                        <div className="txt1 fl">{localLotsIndex + 1 >= 10 ? '' : "0"}{lotsList.length}</div>
                                    </div>
                                    <div className="headerbox clear">
                                        {/* <div className="header-status">{this.state.sessionSituation.statusStr}</div> */}

                                        {/* <div className="header-status">未开始</div> */}
                                        <div className="header-timer countTime fl">
                                            {/* <div className="endTime flex flex_center">结束时间：2020-10-10 18:00:00</div> */}
                                            {(this.state.showCountDown && sessionInfo.status === 0 && localLotsIndex === 0) ||
                                                (sessionInfo.status === 1 && localLotsIndex === sessionSituation.currentLotsIndex) ?
                                                <div className="endTime">
                                                    <div class="iconfont icon-time fl"></div>
                                                    <div className="txt">
                                                        <div className="fl">倒计时：</div>
                                                        <div className="fl">{countDown.hour}</div>
                                                        <div className="fl">:</div>
                                                        <div className="fl">{countDown.minute}</div>
                                                        <div className="fl">:</div>
                                                        <div className="fl">{countDown.second}</div>
                                                        <div className="fl">.</div>
                                                        <div className="fl">{countDown.ms}</div></div>
                                                </div> : ((sessionInfo.status === 1 && localLotsIndex > sessionSituation.currentLotsIndex) ||
                                                    (sessionInfo.status === 0 && localLotsIndex !== 0)) ? <div className="endTime flex flex_center">等待上一台结束</div> :
                                                    (sessionInfo.status === 0) ? <div className="endTime flex flex_center">开始时间：{sessionInfo.startTime}</div> :
                                                        <div className="endTime flex flex_center">结束时间：{lotsList[localLotsIndex].endTime}</div>
                                            }
                                        </div>
                                        <div className="fr">
                                            {sessionInfo.status === 0 ||
                                                (sessionSituation.status === 3 && localLotsIndex === sessionSituation.currentLotsIndex) ||
                                                (sessionInfo.status === 1 && localLotsIndex > sessionSituation.currentLotsIndex) ? <div className="timer-status">未开始</div> :
                                                (sessionSituation.status === 1 && localLotsIndex === sessionSituation.currentLotsIndex) ? <div className="timer-status">竞价中</div> :
                                                    (lotsList[localLotsIndex].status === 0) ? <div className="timer-status">无人出价</div> :
                                                        (lotsList[localLotsIndex].status === 2) ? <div className="timer-status">低于保留价</div> : <div className="timer-status">已结束</div>}
                                        </div>

                                    </div>
                                </div>
                                <div className="visitor-content">
                                    <div className="title">{lotsList[localLotsIndex].name}</div>
                                    <div className="codebox clear">
                                        <div className="productDate fl">{lotsList[localLotsIndex].registerDate ? lotsList[localLotsIndex].registerDate : '未录入'}/
                                        {lotsList[localLotsIndex].mileage ? lotsList[localLotsIndex].mileage + "公里" : '未录入'}</div>
                                        <div className="fr">
                                            <div className="code">车辆编号：{lotsList[localLotsIndex].code}</div>
                                        </div>
                                    </div>

                                    {sessionSituation.status === 1 && localLotsIndex === sessionSituation.currentLotsIndex ?
                                        <div className="price">
                                            <div className="startPrice">￥{this.state.currentPriceStr}元</div>
                                            <div>{this.state.records != null && this.state.records.length > 0 ? '当前最高价' : '起始价'}</div>
                                        </div> :
                                        (sessionInfo.status === 0 || (sessionSituation.status === 3 && localLotsIndex === sessionSituation.currentLotsIndex) ||
                                            (sessionInfo.status === 1 && localLotsIndex > sessionSituation.currentLotsIndex) ||
                                            (sessionInfo.status === 2 && lotsList[localLotsIndex].status !== 1) || (sessionInfo.status === 1 && (lotsList[localLotsIndex].status === 0
                                                || lotsList[localLotsIndex].status === 2))) ? <div className="price">起始价：<span className="startPrice">￥{lotsList[localLotsIndex].startPriceStr}元</span></div> :
                                            <div className="price">
                                                <div className="startPrice">￥{lotsList[localLotsIndex].finalPriceStr}元</div>
                                                <div>当前最高价</div>
                                            </div>
                                    }
                                </div>
                                <div className="offerRecord">
                                    {sessionInfo.status !== 2 ? <div className="listTitle">出价记录(<span>{this.state.bidTimes ? this.state.bidTimes : 0}</span>)</div> : ''}
                                    {
                                        this.state.records.map((item, index) => {
                                            return <div className="offerRecord-item" key={index}>
                                                {index >= 1 ? <div className="tip lowPrice fl">已出局</div> : <div className="tip hightPrice fl">最高价</div>}
                                                <div className="offerTime fl" >￥{item.offer}元</div>
                                                <div className="offerPrice fl">{item.bidTime}</div>
                                            </div>
                                        })
                                    }
                                </div>
                                <div className="baseInfobox">

                                    {this.state.vehicleList.length > 1 ? (this.state.vehicleList.map((item, index) => {
                                        return <Tabs defaultActiveKey="1" animated={false} style={{ width: '100%' }}>
                                            <TabPane tab={'车辆' + (index + 1)} key={index}>
                                                <div className="basicInfo">
                                                    <div className="basicInfobox-brandModel">
                                                        <div className="wp100">
                                                            <span className="txt1">品牌型号</span><span className="txt2">{item.brandModel}</span>
                                                        </div>
                                                    </div>
                                                    <div className="basicInfobox">
                                                        <div className="basic-item fl">
                                                            <div className="txt1">{item.registerDate ? item.registerDate : '未录入'}</div><div className="txt2">初登日期</div>
                                                        </div>
                                                        <div className="basic-item fl">
                                                            <div className="txt1">{item.productionDate ? item.productionDate : '未录入'}</div><div className="txt2">出厂日期</div>
                                                        </div>
                                                        <div className="basic-item fl">
                                                            <div className="txt1">{item.useProperty}</div><div className="txt2">使用性质</div>
                                                        </div>
                                                        <div className="basic-item fl">
                                                            <div className="txt1">{item.registerLocation}</div><div className="txt2">初次登记地</div>
                                                        </div>
                                                        <div className="basic-item fl">
                                                            <div className="txt1">{item.mileage ? item.mileage : '0'}公里</div><div className="txt2">表显里程</div>
                                                        </div>
                                                        <div className="basic-item fl">
                                                            <div className="txt1">{item.fueltype}</div><div className="txt2">能源类型</div>
                                                        </div>
                                                        <div className="basic-item fl">
                                                            <div className="txt1">{item.gearType}</div><div className="txt2">变速器类型</div>
                                                        </div>
                                                        <div className="basic-item fl">
                                                            <div className="txt1">{item.driveMode}</div><div className="txt2">驱动方式</div>
                                                        </div>
                                                        <div className="basic-item fl">
                                                            <div className="txt1">{item.keyNum}把</div><div className="txt2">钥匙数量</div>
                                                        </div>
                                                        <div className="basic-item fl">
                                                            <div className="txt1">{item.examinationDate ? item.examinationDate : '无'}</div><div className="txt2">年检有效期</div>
                                                        </div>
                                                        <div className="basic-item fl">
                                                            <div className="txt1">{item.transferTimes}</div><div className="txt2">过户次数</div>
                                                        </div>
                                                        <div className="basic-item fl">
                                                            <div className="txt1">{item.mortgage === 1 ? '是' : '否'}</div><div className="txt2">是否按揭</div>
                                                        </div>
                                                        <div className="basic-item fl">
                                                            <div className="txt1">{item.commerciaInsuranceDate ? item.commerciaInsuranceDate : "无"}</div><div className="txt2">商业险</div>
                                                        </div>
                                                        <div className="basic-item fl">
                                                            <div className="txt1">{item.mandatoryInsuranceDate ? item.mandatoryInsuranceDate : '无'}</div><div className="txt2">强制险</div>
                                                        </div>
                                                        <div className="basic-item">
                                                            <div className="txt1">{item.recycle ? item.recycle : '无'}</div><div className="txt2">回收配件</div>
                                                        </div>
                                                    </div>
                                                    <div className="basicInfobox-config">
                                                        <div className="basic-config-item wp100">
                                                            <div className="txt1">{item.specialMark ? item.specialMark : '无'}</div><div className="txt2">特殊情况说明</div>
                                                        </div>
                                                        <div className="basic-config-item wp100">
                                                            <div className="txt1">{item.detailHighlight ? item.detailHighlight : '无'}</div><div className="txt2">配置(含加装)</div>
                                                        </div>
                                                        <div className="basic-config-item wp100">
                                                            <div className="txt1">{item.certificate ? item.certificate : '未录入'}</div><div className="txt2">证件</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </TabPane>
                                        </Tabs>
                                    })
                                    ) : this.state.vehicleList.map((item, index) => {
                                        return <div className="basicInfo" key={index}>
                                            <div className="basicInfobox-brandModel">
                                                <div className="wp100">
                                                    <span className="txt1">品牌型号</span><span className="txt2">{item.brandModel}</span>
                                                </div>
                                            </div>
                                            <div className="basicInfobox">
                                                <div className="basic-item fl">
                                                    <div className="txt1">{item.registerDate ? item.registerDate : '未录入'}</div><div className="txt2">初登日期</div>
                                                </div>
                                                <div className="basic-item fl">
                                                    <div className="txt1">{item.productionDate ? item.productionDate : '未录入'}</div><div className="txt2">出厂日期</div>
                                                </div>
                                                <div className="basic-item fl">
                                                    <div className="txt1">{item.useProperty}</div><div className="txt2">使用性质</div>
                                                </div>
                                                <div className="basic-item fl">
                                                    <div className="txt1">{item.registerLocation}</div><div className="txt2">初次登记地</div>
                                                </div>
                                                <div className="basic-item fl">
                                                    <div className="txt1">{item.mileage ? item.mileage : '0'}公里</div><div className="txt2">表显里程</div>
                                                </div>
                                                <div className="basic-item fl">
                                                    <div className="txt1">{item.fueltype}</div><div className="txt2">能源类型</div>
                                                </div>
                                                <div className="basic-item fl">
                                                    <div className="txt1">{item.gearType}</div><div className="txt2">变速器类型</div>
                                                </div>
                                                <div className="basic-item fl">
                                                    <div className="txt1">{item.driveMode}</div><div className="txt2">驱动方式</div>
                                                </div>
                                                <div className="basic-item fl">
                                                    <div className="txt1">{item.keyNum}把</div><div className="txt2">钥匙数量</div>
                                                </div>
                                                <div className="basic-item fl">
                                                    <div className="txt1">{item.examinationDate ? item.examinationDate : '无'}</div><div className="txt2">年检有效期</div>
                                                </div>
                                                <div className="basic-item fl">
                                                    <div className="txt1">{item.transferTimes}</div><div className="txt2">过户次数</div>
                                                </div>
                                                <div className="basic-item fl">
                                                    <div className="txt1">{item.mortgage === 1 ? '是' : '否'}</div><div className="txt2">是否按揭</div>
                                                </div>
                                                <div className="basic-item fl">
                                                    <div className="txt1">{item.commerciaInsuranceDate ? item.commerciaInsuranceDate : "无"}</div><div className="txt2">商业险</div>
                                                </div>
                                                <div className="basic-item fl">
                                                    <div className="txt1">{item.mandatoryInsuranceDate ? item.mandatoryInsuranceDate : '无'}</div><div className="txt2">强制险</div>
                                                </div>
                                                <div className="basic-item">
                                                    <div className="txt1">{item.recycle ? item.recycle : '无'}</div><div className="txt2">回收配件</div>
                                                </div>
                                            </div>
                                            <div className="basicInfobox-config">
                                                <div className="basic-config-item wp100">
                                                    <div className="txt1">{item.specialMark ? item.specialMark : '无'}</div><div className="txt2">特殊情况说明</div>
                                                </div>
                                                <div className="basic-config-item wp100">
                                                    <div className="txt1">{item.detailHighlight ? item.detailHighlight : '无'}</div><div className="txt2">配置(含加装)</div>
                                                </div>
                                                <div className="basic-config-item wp100">
                                                    <div className="txt1">{item.certificate ? item.certificate : '未录入'}</div><div className="txt2">证件</div>
                                                </div>
                                            </div>
                                        </div>
                                    })}
                                </div>
                                <div className="golist" onClick={this.goLotsList}>查看竞价品列表</div>
                                <Modal
                                    title={this.state.bidResultInfo.title}
                                    visible={this.state.bidResultInfo.visible}
                                    onOk={this.handleOk}
                                    closable={false}
                                    footer={[
                                        <Button key="submit" type="primary" disabled={true} onClick={this.handleOk}>{'进入下一个竞价品' + this.state.bidResultInfo.nextBidSecond + "s"} </Button>,
                                    ]}
                                >
                                    <div>{this.state.bidResultInfo.content}</div>
                                </Modal>
                            </div>
                            : <VisitorList
                                sessionInfo={this.state.sessionInfo}
                                countDown={this.state.countDown}
                                sessionSituation={this.state.sessionSituation}
                                detail={this.detail.bind(this)}
                                closeModal={this.closeVisitorListModal.bind(this)}
                                showCountDown={this.state.showCountDown}
                            />}
                    </div>
                );
            }
        }
        return htmlStr
    }

}

export default Visitor;